import { RestrictMultipleSubmit } from "../../_modules/restrict-multiple-submit"

class RestrictMultipleSubmitInit {
    constructor() {
        RestrictMultipleSubmit.setRestrictMultipleSubmit();
    }
};

document.addEventListener('DOMContentLoaded', () => {
    const _ = new RestrictMultipleSubmitInit();
});
